const FirstPageHeader = () => {
    return (
        <header className="firstpage-header">
            <a href="https://joepet-ryan-quimora.itch.io/trivtionary" className="header-a">Mobile app</a>
            <a href="https://m.me/trivtionary" className="header-a">Messenger Bot</a>
        </header>
    )
}

export default FirstPageHeader
